export default __webpack_public_path__ + "static/media/fractionMultiplication.5d8490f5.svg";